var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCancel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 492 492",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #000;\n        stroke-width: 0px;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M300.2,246L484.1,62c5.1-5.1,7.9-11.8,7.9-19,0-7.2-2.8-14-7.9-19l-16.1-16.1C463,2.8,456.2,0,449,0s-14,2.8-19,7.9l-183.9,183.9L62,7.9C57,2.8,50.2,0,43,0s-14,2.8-19,7.9L7.9,24c-10.5,10.5-10.5,27.6,0,38l184,184L7.9,429.9C2.8,435,0,441.8,0,449s2.8,14,7.8,19l16.1,16.1c5.1,5.1,11.8,7.9,19,7.9s14-2.8,19-7.9l184-184,184,184c5.1,5.1,11.8,7.9,19,7.9h0c7.2,0,14-2.8,19-7.9l16.1-16.1c5.1-5.1,7.9-11.8,7.9-19s-2.8-14-7.9-19l-184-184h0Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCancel);
export default __webpack_public_path__ + "static/media/cancel.05e0a6cfc0e442c1a3beda4b1a7ebe43.svg";
export { ForwardRef as ReactComponent };